'use client'

import { useProductCard } from 'product-card/hooks/useProductCard'
import { useProductCardConsumerLayoutContext } from 'product-card/hooks/useProductCardConsumerLayoutContext'
import { useProductImages } from 'product-card/hooks/useProductImages/useProductImages'
import { useShowAsFeatured } from 'product-card/hooks/useShowAsFeatured/useShowAsFeatured'
import { ImageDisplayType } from 'product-card/types'
import { getPanoramicImage } from 'product-card/utils/getPanoramicImage/getPanoramicImage'
import { sortImagesByOrder } from 'product-card/utils/sortImagesByOrder'
import { useMemo } from 'react'
import { env } from 'utils/envManager'
import { PdpImageLinkWrapper } from './PdpImageLinkWrapper/PdpImageLinkWrapper'
import { ProductImageSlideshow } from './ProductImageSlideshow/ProductImageSlideshow'
import { SingleProductImage } from './SingleProductImage/SingleProductImage'

export const ProductImage = () => {
	const { imageSortCriteria } = useProductCard()

	const showAsFeatured = useShowAsFeatured()
	const images = useProductImages()

	const sortedImages = useMemo(() => {
		if (showAsFeatured) {
			return [getPanoramicImage(images)]
		}
		return sortImagesByOrder(images, imageSortCriteria)
	}, [images, imageSortCriteria, showAsFeatured])

	const { shouldRenderSlider } = useProductCardConsumerLayoutContext()

	const imageDisplayType =
		sortedImages.length === 1 || !shouldRenderSlider
			? ImageDisplayType.Single
			: ImageDisplayType.Slider

	const [firstImage] = sortedImages

	return (
		<PdpImageLinkWrapper imageDisplayType={imageDisplayType}>
			<meta
				itemProp='image'
				content={new URL(firstImage.img, env.NEXT_PUBLIC_SITE_BASE_URL).href}
			/>
			{imageDisplayType === ImageDisplayType.Single ? (
				<SingleProductImage image={firstImage} />
			) : (
				<ProductImageSlideshow images={sortedImages} />
			)}
		</PdpImageLinkWrapper>
	)
}
